module.exports = __webpack_public_path__ + "static/aws_devops-4427b0283fd12140f48c9074b3c7577c.png";